__webpack_require__.p = "/rest-api-countries/";